import React,{useEffect} from 'react'


import "./Under.css"

const bg = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/underconstruction/uct.webp"
const bg_mob = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/underconstruction/uctmob.webp"
const Under = () => {
  useEffect(() => {
    document.title = 'Under Construction';
  }, []);
  return (
    <div>
        <div className='underbg'>
            <img className='uct_bg' src={bg} alt='bg'/>
            <img className='uct_bg_mob' src={bg_mob} alt='bg_mob'/>
        </div>
    </div>
  )
}

export default Under